import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

import { ActivityDropdown } from './activity-dropdown';
import { ActivityModal } from './activity-modal';
import { ErrorDropdown } from './error-dropdown';

import envAPI from '../../../api/api-env';
import { FormattedMessage, injectIntl } from 'react-intl';
import SharedIntlProviderHOC from 'shared-components/hocs/sharedIntlProviderHOC';

class ActivitySearch extends Component {
  constructor (props) {
    super(props);

    this.onActivityChange = this.onActivityChange.bind(this);
    this.onActivityFocus = this.onActivityFocus.bind(this);
    this.onActivityKeydown = this.onActivityKeydown.bind(this);
    this.closeActivityDropDown = this.closeActivityDropDown.bind(this);
    this.openActivityDropDown = this.openActivityDropDown.bind(this);
    this.openActivityModal = this.openActivityModal.bind(this);
    this.onActivityClick = this.onActivityClick.bind(this);
    this.modalActivityClick = this.modalActivityClick.bind(this);
    this.isValid = this.isValid.bind(this);
    this.checkForError = this.checkForError.bind(this);
    this.onActivityBlur = this.onActivityBlur.bind(this);
    this.checkForIcon = this.checkForIcon.bind(this);

    this.state = {
      activity: '',
      activities: [],
      activityDefaults: [],
      activitySuggestions: [],
      activityMenu: '',
      enableAClickOutside: false,
      userSelected: false,
      error: {}
    };
  }

  componentWillMount () {
    if (this.props.activity) {
      this.setState({ userSelected: true });
    }
  }

  componentDidMount () {
    const locale = SharedIntlProviderHOC.getLocale();
    envAPI.getActivities(locale, res => {
      const activities = res.response;
      const defaults = [
        this.props.intl.formatMessage({ id: 'boards.activity_search.meeting', defaultMessage: 'Meeting' }),
        this.props.intl.formatMessage({ id: 'boards.activity_search.film_shoot', defaultMessage: 'Film Shoot' }),
        this.props.intl.formatMessage({ id: 'boards.activity_search.corporate_event', defaultMessage: 'Corporate Event' }),
        this.props.intl.formatMessage({ id: 'boards.activity_search.workshop', defaultMessage: 'Workshop' }),
        this.props.intl.formatMessage({ id: 'boards.activity_search.party', defaultMessage: 'Party' })
      ];
      const activityDefaults = _.filter(activities, (a) => {
        return -1 !== defaults.indexOf(a.dropdown);
      });

      const { Sifter } = window;

      this.setState({
        activities,
        activityDefaults,
        sifter: new Sifter(activities)
      });
    });
  }

  componentWillUpdate (nextProps, nextState) {
    const { userSelected } = nextState;
    if (this.state.userSelected && (userSelected !== this.state.userSelected)) {
      this.props.clickCallback('');
    }
  }

  onActivityChange (e) {
    const activity = e ? e.currentTarget.value : '';

    this.setState({
      activity,
      userSelected: false
    }, () => {
      if (activity) {
        this.setState({
          activitySuggestions: this.getActivitySuggestions(activity)
        });
      } else {
        this.setState({
          activitySuggestions: []
        });
      }
    });
  }

  onActivityKeydown (e) {
    if (40 === e.keyCode) {
      e.preventDefault();
      $('#act-list-0 a').focus();
    } else if (13 === e.keyCode) {
      if (this.state.activitySuggestions) {
        $('#act-list-0').trigger('click');
        $(e.currentTarget).trigger('blur');
      }
    }
  }

  openActivityModal (e) {
    e.preventDefault();
    const { seeMoreAction } = this.props;
    const { activities } = this.state;
    const useTypes = _.uniqBy(activities, 'use_subtype');

    if (seeMoreAction) {
      return seeMoreAction(useTypes);
    }

    return ReactDOM.render(
      <SharedIntlProviderHOC>
        <ActivityModal
          activities={useTypes}
          handleActivityClick={this.modalActivityClick}
          closeDropdown={this.closeActivityDropDown}
          origin="modal"
        />
      </SharedIntlProviderHOC>,
      document.getElementById('modal-container')
    );
  }

  modalActivityClick (e) {
    this.onActivityClick(e, null, true);
  }

  onActivityFocus (e) {
    this.setState({
      activityFocus: true,
      activityPlaceholder: this.props.intl.formatMessage({ id: 'boards.activity_search.enter_activity', defaultMessage: 'Enter your specific activity' })
    });

    if (e) {
      e.currentTarget.select();
      const inputValue = e.currentTarget.value;
      if (inputValue) {
        this.setState({
          activity: inputValue,
          activitySuggestions: this.getActivitySuggestions(inputValue)
        });
      }
    }

    this.openActivityDropDown();
  }

  onActivityBlur (e) {
    e.stopPropagation();
    this.setState({
      activityFocus: false,
      activityPlaceholder: this.props.intl.formatMessage({ id: 'boards.activity_search.what_planning', defaultMessage: 'What are you planning?' })
    });
    return setTimeout(() => {
      this.errorFn();
    }, 200);
  }

  openActivityDropDown () {
    this.setState({
      activityMenu: 'open',
      enableAClickOutside: true
    });
  }

  closeActivityDropDown () {
    this.setState({
      activityMenu: '',
      enableAClickOutside: false
    });
  }

  onActivityClick (e, f, modal) {
    e.stopPropagation();
    e.preventDefault();
    const targetElement = e.currentTarget;
    const typedActivityValue = this.refs.activityInput.value;
    const skt = modal ? 'modal' : typedActivityValue ? 'input' : 'default';
    const activityValue = targetElement.getAttribute('data-name');
    const activityId = targetElement.getAttribute('data-id');
    this.refs.activityInput.value = activityValue;
    this.refs.activityInput.setAttribute('data-id', activityId);
    this.closeActivityDropDown();
    PSSessions.Cookies.set('PSSK', activityValue, Date.now() + 3888000000);
    PSSessions.Cookies.set('PSSKT', skt, Date.now() + 3888000000);
    this.setState({
      activity: activityValue,
      userSelected: true
    }, () => {
      this.errorFn(true);
      this.props.clickCallback(activityValue);
    });
  }

  getActivitySuggestions (input) {
    const droptions = [];
    this.state.sifter.search(input, { fields: ['dropdown', 'use-subtype', 'display_use_type'], limit: 5 })
      .items.forEach((element) => {
        droptions.push(this.state.activities[element.id]);
      });

    return droptions;
  }

  isValid () {
    const { activity } = this.props;
    let errorFree = true;

    if (!activity) { errorFree = false; }

    this.errorFn();
    return errorFree;
  }

  getValue () {
    const { activity } = this.props;
    return activity;
  }

  errorFn (hasActivity) {
    const { activity } = this.props;
    let error = this.invalidState();

    if (activity || hasActivity) {
      error = this.validState();
    }
    this.setState({ error });
  }

  validState () {
    const errorObj = {};
    errorObj.inputBorder = '';
    errorObj.errorMsg = '';
    return errorObj;
  }

  invalidState () {
    const errorObj = {};
    errorObj.inputBorder = 'error';
    errorObj.errorMsg = this.props.intl.formatMessage({ id: 'boards.activity_search.activity_error', defaultMessage: 'Please enter a valid activity.' });
    return errorObj;
  }

  checkForError () {
    const { error } = this.state;

    if (error.errorMsg) {
      return (
        <div className="col-xs-12">
          <p className={"help-block inline-help text-danger text-left"}>{error.errorMsg}</p>
        </div>
      );
    }
    return null;
  }

  checkForIcon () {
    let icon = '';
    if (!this.props.optional) {
      icon = <span className="required">*</span>;
    }
    return (
      <div className="form-control-feedback">
        {icon}
      </div>
    );
  }

  render () {
    const { activity, activityDefaults, activitySuggestions, activityMenu, enableAClickOutside, error } = this.state;
    const actBlurred = this.state.activityFocus ? '' : 'blurred';
    const activityClass = 'js-searchbar-select-metro-modal';
    const errorBorder = error.inputBorder || '';

    return (
      <div>
        <div className="form-group has-feedback activity-search">
          <label className={`control-label text-left vert-align-label`}>
            <FormattedMessage
              id="boards.activity_search.activity"
              defaultMessage="Activity"
            />
          </label>
          <div className={`search-group use-type-input dropdown ${activityMenu}`}>
            <input
              aria-haspopup="true"
              aria-expanded="false"
              id="activity-input"
              type="text"
              className={`form-control ${activityClass} ignore-activity-clickoutside ${actBlurred} ${errorBorder}`}
              onFocus={this.onActivityFocus}
              onBlur={this.onActivityBlur}
              onChange={this.onActivityChange}
              onKeyDown={this.onActivityKeydown}
              placeholder={this.state.activityPlaceholder || this.props.intl.formatMessage({ id: 'boards.activity_search.what_planning_placeholder', defaultMessage: 'What are you planning?' })}
              defaultValue={this.props.activity}
              tabIndex="0"
              ref="activityInput"
            />
            { this.checkForIcon() }
            {
              activity && activitySuggestions && !activitySuggestions.length ?
                <ErrorDropdown
                  content={<span>
                    <FormattedMessage
                      id="boards.activity_search.dont_recognize"
                      defaultMessage="We don't recognize that activity. Try describing it differently or {popular}"
                      values={{
                        popular: (
                          <span className="link-span inline" onClick={this.openActivityModal} >
                            <FormattedMessage
                              id="boards.activity_search.popular_activities"
                              defaultMessage="pick from popular activities."
                            />
                          </span>
                        )
                      }}
                    />
                  </span>}
                  enableClickOutside={this.state.enableAClickOutside}
                  closeDropdown={this.closeActivityDropDown}
                  origin={this.props.origin}
                  ignoreClass="ignore-activity-clickoutside"
                />
                :
                <ActivityDropdown
                  defaults={ activityDefaults }
                  suggestions={ activitySuggestions }
                  activityValue={ activity }
                  clickFn={ this.onActivityClick }
                  closeDropdown={ this.closeActivityDropDown }
                  seeMoreAction={ this.openActivityModal }
                  enableClickOutside={enableAClickOutside}
                  hideSeeMoreActivity={this.props.hideSeeMoreActivity}
                  clickOutsideClass="ignore-activity-clickoutside"
                />
            }
          </div>
          {this.checkForError()}
        </div>
      </div>
    );
  }
}

ActivitySearch.propTypes = {
  activity: PropTypes.string,
  clickCallback: PropTypes.func,
  seeMoreAction: PropTypes.func,
  optional: PropTypes.bool,
  origin: PropTypes.string,
  hideSeeMoreActivity: PropTypes.bool
};

exports.ActivitySearch = injectIntl(ActivitySearch, { withRef: true });
